///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/store/inbox/historyCategory"/>
import { createLocalStore } from "Core/Medius.Core.Web/Scripts/Medius/lib/store/async";

const prefix = "Core:inbox-history-category";

export const historyStore = createLocalStore(prefix);